import React, { useEffect } from "react";
import "./DocumentUploadRxModal.scss";

import { ReactComponent as UploadIcon } from "assets/icons/upload-icon.svg";

import {
  Col,
  Form,
  Input,
  Modal,
  Row,
  Button,
  Upload,
  Select,
  Spin,
  Typography,
  Icon,
} from "antd";

import LoadingIndicator from "components/LoadingIndicator";

import { formatDouble } from "utils/utils";

import { connect } from "react-redux";

import { FormattedMessage, useIntl } from "react-intl";
import moment from "moment";

import {
  displayError,
  displayGenericError,
  displaySuccessMessage,
} from "common/notifications";

import {
  setModalVisible,
  cleanup,
  setSelectedType,
  addUploadedFile,
  addUploadedFileType,
  addUploadedFilename,
  addUploadedFileSize,
  setLoading,
  deleteUploadedFile,
} from "rx/documentupload";

const confirm = Modal.confirm;
const { Title, Text, Paragraph } = Typography;
const { Dragger } = Upload;

function DocumentUploadRxModal(props) {
  const intl = useIntl();

  useEffect(() => {}, []);

  var docTypes = [
    {
      value: "PAYMENT_INVOICE",
      label: `${intl.formatMessage({
        id: "app.modal.order.document.payment.invoice",
      })}`,
    },
    {
      value: "COMMERCIAL_AGREEMENT",
      label: `${intl.formatMessage({
        id: "app.modal.order.document.commercial.agreement",
      })}`,
    },
    {
      value: "LOGISTICS_DOCUMENTATION",
      label: `${intl.formatMessage({
        id: "app.modal.order.document.logistics.documentation",
      })}`,
    },
    {
      value: "CUSTOMS_DECLARATION",
      label: `${intl.formatMessage({
        id: "app.modal.order.document.payment.customsdeclaration",
      })}`,
    },
    {
      value: "PAYMENT_SLIP",
      label: `${intl.formatMessage({
        id: "app.modal.order.document.payslips",
      })}`,
    },
    {
      value: "OTHER",
      label: `${intl.formatMessage({ id: "app.modal.order.document.others" })}`,
    },
  ];

  return (
    <>
      <Modal
        width={1000}
        className="documentUploadModal"
        visible={props.modalVisible}
        onOk={() => props.setModalVisible(false)}
        onCancel={() => props.setModalVisible(false)}
        title={intl.formatMessage({ id: "app.common.upload.order.documents" })}
      >
        {props.loading && <LoadingIndicator />}
        <Row gutter={16}>
          <Col className="gutter-row" span={8}></Col>
          <Col className="gutter-row" span={8}></Col>
          <Col className="gutter-row" span={8}></Col>
        </Row>
        <div className="general-info-tab">
          <div className="left-pane" style={{ paddingTop: 10 }}>
            <div className="upload-wrapper">
              <Row gutter={24}>
                <Col md={14}>
                  <p>
                    <b>
                      {intl.formatMessage({
                        id: "app.modal.documentorderuploading.select.document",
                      })}
                    </b>
                  </p>
                  <Select
                    showSearch
                    //{...props}
                    style={{ width: 300, ...props.style }}
                    size="large"
                    placeholder={intl.formatMessage({
                      id: "app.common.select",
                    })}
                    optionFilterProp="children"
                    onChange={(val) => props.setSelectedType(val)}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    mode={props.mode || "default"}
                  >
                    {docTypes.map((item) => {
                      return (
                        <Select.Option value={item.value}>
                          {item.label}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Col>
                <Col md={10}>
                  {props.selectedType ? (
                    <div
                      style={{
                        textAlign: "center",
                      }}
                    >
                      <Upload
                        style={{
                          width: "100%",
                          height: "90px",
                          cursor: "pointer",
                          borderStyle: "dashed",
                          borderColor: "#6d6d6d",
                          borderWidth: "1px",
                          display: "block",
                          backgroundColor: "#f5f5f5",
                          paddingTop: "18px",
                          paddingLeft: "80px",
                          paddingRight: "80px",
                        }}
                        accept={".pdf,.png,.jpg,.jpeg,.bmp,.doc,.docx,image/*"}
                        beforeUpload={(file) => handleBeforeUpload(file, intl)}
                        name="file"
                        disabled={props.selectedType == null}
                        customRequest={(info) => handleUpload(props, info)}
                        showUploadList={false}
                      >
                        {props.loading ? <Spin /> : <UploadIcon />}
                        <div>
                          <Text style={{ fontSize: "13px" }}>
                            <FormattedMessage id="app.modal.uploadwrapper.dragyourfile" />
                          </Text>
                        </div>
                      </Upload>
                    </div>
                  ) : null}
                </Col>
              </Row>
              <Row gutter={24}>
                <Col md={24}>
                  {props.uploadedFileTypes.length > 0 && (
                    <table className="documentUploadTable">
                      <tr>
                        <th style={{ width: "60px" }}>
                          <FormattedMessage id="app.common.index" />
                        </th>
                        <th>
                          <FormattedMessage id="app.common.document.type" />
                        </th>
                        <th>
                          <FormattedMessage id="app.common.file.name" />
                        </th>
                        <th>
                          <FormattedMessage id="app.common.file.size" />
                        </th>
                        <th>
                          <FormattedMessage id="app.common.file" />
                        </th>
                        <th style={{ width: "60px" }}>
                          <FormattedMessage id="app.common.delete" />
                        </th>
                      </tr>
                      {props.uploadedFileTypes.map(
                        (uploadedFileType, index) => {
                          return (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{uploadedFileType}</td>
                              <td>{props.uploadedFilenames[index]}</td>
                              <td>
                                {formatDouble(
                                  props.uploadedFileSizes[index] / 1024,
                                  0
                                )}
                                kb
                              </td>
                              <td>
                                <a
                                  target="_blank"
                                  href={props.uploadedFiles[index]}
                                >
                                  <FormattedMessage id="app.common.download" />
                                </a>
                              </td>
                              <td>
                                <Icon
                                  type="close"
                                  onClick={() =>
                                    props.deleteUploadedFile(index)
                                  }
                                />
                              </td>
                            </tr>
                          );
                        }
                      )}
                    </table>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

const handleBeforeUpload = (file, intl) => {
  const isUnderLimit = file.size / 1024 / 1024 < 10; // < 10MB
  if (!isUnderLimit) {
    displayGenericError({
      message: intl.formatMessage({ id: "app.common.upload.file.limit" }),
    });
  }
  return isUnderLimit;
};

const handleUpload = async (props, info) => {
  props.setLoading(true);

  //console.log(info);
  let { file, type, index, fileList, status, onSuccess, onProgress } = info;

  var fileUrl = URL.createObjectURL(file);

  //console.log(fileUrl);
  props.addUploadedFile(fileUrl);
  props.addUploadedFileType(props.selectedType);
  props.addUploadedFileSize(file.size);
  props.addUploadedFilename(file.name);

  props.setLoading(false);
};

const mapStateToProps = (state) => {
  return {
    loading: state.documentUpload.loading,
    modalVisible: state.documentUpload.modalVisible,
    selectedType: state.documentUpload.selectedType,
    uploadedFileTypes: state.documentUpload.uploadedFileTypes,
    uploadedFiles: state.documentUpload.uploadedFiles,
    uploadedFilenames: state.documentUpload.uploadedFilenames,
    uploadedFileSizes: state.documentUpload.uploadedFileSizes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    cleanup: () => dispatch(cleanup()),
    setLoading: (loading) => dispatch(setLoading(loading)),
    setModalVisible: (modalVisible) => dispatch(setModalVisible(modalVisible)),
    setSelectedType: (selectedType) => dispatch(setSelectedType(selectedType)),
    addUploadedFile: (fileUrl) => dispatch(addUploadedFile(fileUrl)),
    addUploadedFileType: (fileType) => dispatch(addUploadedFileType(fileType)),
    addUploadedFilename: (filename) => dispatch(addUploadedFilename(filename)),
    addUploadedFileSize: (fileSize) => dispatch(addUploadedFileSize(fileSize)),
    deleteUploadedFile: (index) => dispatch(deleteUploadedFile(index)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentUploadRxModal);
